import 'whatwg-fetch'
import { setCookie } from 'tiny-cookie'

import cache from '../../js/utilities/cache'

const enable = (consent = true) => {
  const $form = cache.$formSignup

  $form.on('submit', (e) => {
    e.preventDefault()

    const data = new URLSearchParams()

    if (consent) setCookie('seedlip-stored-modal-newsletter', true, { expires: '1M' })

    if (e.target.checkValidity()) {
      for (const pair of new FormData($form[0])) {
        data.append(pair[0], pair[1])
      }

      if (consent) {
        fetch('https://api.ometria.com/forms/signup', {
          body: data,
          method: 'post',
          mode: 'no-cors',
        })
          .then(res => res.text())
          .then(() => {
            document.body.classList.remove('modal--newsletter--active')
            document.body.classList.add('modal--newsletter-thankyou--active')
          })
          .catch(err => console.error(err))
      } else {
        document.body.classList.remove('modal--newsletter--active')
        document.body.classList.add('modal--newsletter-thankyou--active')
      }
    }
  })
}

export default { enable }
